var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        'app-container g-h-full': true,
        'g-m-auto': !_vm.isOnCampaignOrActivation,
        'campaign-activation-container': _vm.isOnCampaignOrActivation
    }},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }